import React, { Component } from 'react';
import { withTranslation, WithTranslationProps } from 'react-i18next';
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"
import './index.css'

type StateProps = {
    static: any
}

class FootPartition extends Component<StateProps & WithTranslationProps> {

    componentDidMount () {
        let domLeft = document.getElementById("feetPartitionCanvasLeft");
        this.createCanvas(domLeft, "left");
        let domRight = document.getElementById("feetPartitionCanvasRight");
        this.createCanvas(domRight, "right");
    }

    createCanvas = (dom, type) => {
        let ctx = dom.getContext("2d");
        const report  = this.props.static;
        const data = report[type].regionImage;
        const canvasWidth = 400, canvasHeight = 400;

        const that = this;
        let img = new Image();
        img.crossOrigin = "anonymous";
        img.src = data.imageUrl;
        img.onload = function () {
            const imgWidth = img.width;
            const imgHeight = img.height;
            // console.log(imgWidth, imgHeight);

            let width = canvasHeight / imgHeight * imgWidth;
            let px = (canvasWidth - width) / 2;

            ctx.translate(px, 0);
            ctx.scale(canvasHeight / imgHeight, canvasHeight / imgHeight);

            ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

            let yA = 0
            if(report[type].toesForefootHorizontalLine) {
                yA = report[type].toesForefootHorizontalLine;
            }
            let yB = report[type].forefootMidfootHorizontalLine;
            let yC = report[type].midfootHeelHorizontalLine;

            let rectHeight = 0;
            ctx.globalAlpha = 0.2;

            that.drawLine(ctx, {x: 0, y: yA}, {x: imgWidth, y: yA});
            rectHeight = yB - yA;

            ctx.fillStyle = "#EF4646";
            ctx.fillRect(0, yA, imgWidth, rectHeight);
            ctx.fill();

            that.drawLine(ctx,{x: 0, y: yB}, {x: imgWidth, y: yB});
            rectHeight = yC - yB;

            ctx.fillStyle = "#619CFF";
            ctx.fillRect(0, yB, imgWidth, rectHeight);
            ctx.fill();
            
            that.drawLine(ctx,{x: 0, y: yC}, {x: imgWidth, y: yC});
            rectHeight = imgHeight - yB;

            ctx.fillStyle = '#41D775';
            ctx.fillRect(0, yC, imgWidth, rectHeight);
            ctx.fill();

            that.drawLine(ctx, {x: 0, y: imgHeight}, {x: imgWidth, y: imgHeight});

            ctx.globalAlpha = 1;
            ctx.strokeStyle = '#A3A3A3';

            // 画足轴线
            that.drawDashed(ctx, data.vLine.onePoi, data.vLine.anotherPoi);

            // 画区域线
            ctx.strokeStyle = '#A3A3A3';
            if(data.t1T2345VLine) {
                that.drawLine(ctx, data.t1T2345VLine.onePoi, data.t1T2345VLine.anotherPoi);
            }
            that.drawLine(ctx, data.m1M2VLine.onePoi, data.m1M2VLine.anotherPoi);
            that.drawLine(ctx, data.m2M3VLine.onePoi, data.m2M3VLine.anotherPoi);
            that.drawLine(ctx, data.m3M4VLine.onePoi, data.m3M4VLine.anotherPoi);
            that.drawLine(ctx, data.m4M5VLine.onePoi, data.m4M5VLine.anotherPoi);

            // 画点
            ctx.font = "4px sans-serif";
            ctx.fillStyle = "#000";
            if(data.t1) {
                ctx.fillText("T1", data.t1.x - 2, data.t1.y);
            }
            if(data.t2345) {
                ctx.fillText("T2345", data.t2345.x - 2, data.t2345.y);
            }
            ctx.fillText("M1", data.m1.x - 2, data.m1.y);
            ctx.fillText("M2", data.m2.x - 2, data.m2.y);
            ctx.fillText("M3", data.m3.x - 2, data.m3.y);
            ctx.fillText("M4", data.m4.x - 2, data.m4.y);
            ctx.fillText("M5", data.m5.x - 2, data.m5.y);
            ctx.fillText("MF", data.mf.x - 2, data.mf.y);
            ctx.fillText("MH", data.mrf.x - 2, data.mrf.y);
            ctx.fillText("LH", data.lrf.x - 2, data.lrf.y);

        }

    }

    drawLine = (ctx, point1, point2) => {
        ctx.beginPath()
        ctx.lineWidth = 0.5;
        ctx.setLineDash([1, 0]);
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point2.x, point2.y);
        ctx.closePath()
        ctx.stroke()
    }

    drawDashed = (ctx, point1, point2) => {
        ctx.beginPath()
        ctx.lineWidth = 0.5;
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point2.x, point2.y);
        ctx.setLineDash([1, 2]);
        ctx.closePath()
        ctx.stroke()
    }

    returnTitle = (key) => {
        const i18n = this.props.i18n;
        switch (key) {
            case "t1": return "T1 " + i18n?.t("bigToeThumb");
            case "t2345": return "T2,3,4,5 " + i18n?.t("littleToe");
            case "m1": return "M1 (Meta 1)";
            case "m2": return "M2 (Meta 2)";
            case "m3": return "M3 (Meta 3)";
            case "m4": return "M4 (Meta 4)";
            case "m5": return "M5 (Meta 5)";
            case "midfoot": return "MF (" + i18n?.t("inFoot") + ")";
            case "mrf": return "MH (" + i18n?.t("insideHeel") + ")";
            case "lrf": return "LH (" + i18n?.t("lateralHeel") + ")";
            default: return "";
        }
    }

    returnData = () => {
        const report = this.props.static;
        let data: any = {
            left: [],
            right: []
        }
        if (!report.left || !report.right) {
            return data
        }

        const keyArr = [
            "t1", "t2345", "m1", "m2", "m3", "m4", "m5",
            "midfoot", "mrf", "lrf"
        ];
        for (let i = 0; i < keyArr.length; i++) {
            let key = keyArr[i];
            if(report.left[key]) {
                data.left.push({
                    key: key,
                    name: this.returnTitle(key),
                    area: (report.left[key].area / 100).toFixed(1),
                    areaOverSelfSide: (report.left[key].areaOverSelfSide * 100).toFixed(1),
                    load: (report.left[key].load).toFixed(1),
                    loadOverSelfSide: (report.left[key].loadOverSelfSide * 100).toFixed(1),
                    pressureMax: (report.left[key].pressureMax / 1000).toFixed(0),
                    pressureMean: (report.left[key].pressureMean / 1000).toFixed(0),
                });
            }
            else {
                data.left.push({
                    key: key,
                    name: this.returnTitle(key),
                    area: 0.0,
                    areaOverSelfSide: 0.0,
                    load: 0.0,
                    loadOverSelfSide: 0.0,
                    pressureMax: 0,
                    pressureMean: 0,
                });
            }

            if(report.right[key]) {
                data.right.push({
                    key: key,
                    name: this.returnTitle(key),
                    area: (report.right[key].area / 100).toFixed(1),
                    areaOverSelfSide: (report.right[key].areaOverSelfSide * 100).toFixed(1),
                    load: (report.right[key].load).toFixed(1),
                    loadOverSelfSide: (report.right[key].loadOverSelfSide * 100).toFixed(1),
                    pressureMax: (report.right[key].pressureMax / 1000).toFixed(0),
                    pressureMean: (report.right[key].pressureMean / 1000).toFixed(0),
                });
            }
            else {
                data.right.push({
                    key: key,
                    name: this.returnTitle(key),
                    area: 0.0,
                    areaOverSelfSide: 0.0,
                    load: 0.0,
                    loadOverSelfSide: 0.0,
                    pressureMax: 0,
                    pressureMean: 0,
                });
            }
        }
        return data;
    }

    returnEversionText = (key) => {
        const i18n = this.props.i18n;

        switch(key) {
            case "NORMAL":  return {
                label: i18n?.t("footNormal"),
                text: i18n?.t("footNormalConclusion")
            }
            case "FOREFOOT_INVERSION":  return {
                label: i18n?.t("forefootInversion"),
                text: i18n?.t("forefootInversionConclusion")
            }
            case "FOREFOOT_EVERSION":  return {
                label: i18n?.t("forefootEversion"),
                text: i18n?.t("forefootEversionConclusion")
            }
            case "HEEL_INVERSION":  return {
                label: i18n?.t("heelInversion"),
                text: i18n?.t("heelInversionConclusion")
            }
            case "HEEL_EVERSION":  return {
                label: i18n?.t("heelEversion"),
                text: i18n?.t("heelEversionConclusion")
            }
            case "FOOT_INVERSION":  return {
                label: i18n?.t("footInversion"),
                text: i18n?.t("footInversionConclusion")
            }
            case "FOOT_EVERSION":  return {
                label: i18n?.t("footEversion"),
                text: i18n?.t("footEversionConclusion")
            }
            default:  return {
                label: "",
                text: ""
            }
        }

    }
    returnConclusion = () => {
        const report = this.props.static;
        let data: any = {
            left: {
                label: "",
                text: []
            },
            right: {
                label: "",
                text: []
            }
        }
        if (!report.left || !report.right) {
            return data
        }
        let labelArr: string[] = [];
        report.left.eversionInversionOfFootList.map((item) => {
            let obj = this.returnEversionText(item)
            if(obj.label) labelArr.push(obj.label)
            if(obj.text) data.left.text.push(obj.text)
        })
        data.left.label = labelArr.join("、")

        labelArr = []
        report.right.eversionInversionOfFootList.map((item) => {
            let obj = this.returnEversionText(item)
            if(obj.label) labelArr.push(obj.label)
            if(obj.text) data.right.text.push(obj.text)
        })
        data.right.label = labelArr.join("、")

        return data;

    }

    render() {

        const data = this.returnData();
        const conclusion = this.returnConclusion();
        const i18n = this.props.i18n;

        return (
            <div className="standing-feet-partition">
                <p className='reportCom-container-title'>
                    {/* <img src={icon_reportDetail_head} alt="icon head" /> */}
                    <span>{i18n?.t("staticFootParameters")}</span>
                </p>
                <ul>
                    <li>
                        <div>
                            <canvas id="feetPartitionCanvasLeft" width="400" height="400"></canvas>
                        </div>
                    </li>
                    <li>
                        <div>
                            <canvas id="feetPartitionCanvasRight" width="400" height="400"></canvas>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li>
                        <table>
                            <thead>
                                <tr>
                                    <th>{`${i18n?.t("area")}(${i18n?.t("left")})`}</th>
                                    <th>{i18n?.t("superficialArea")}</th>
                                    <th>%</th>
                                    <th>{i18n?.t("force")}</th>
                                    <th>%</th>
                                    <th>{i18n?.t("maxPressure")}</th>
                                    <th>{i18n?.t("averagePressure")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.left.map((item) => {
                                        return (
                                            <tr key={item.key}>
                                                <td>{item.name}</td>
                                                <td>{item.area} cm²</td>
                                                <td>{item.areaOverSelfSide}%</td>
                                                <td>{item.load} Kgf</td>
                                                <td>{item.loadOverSelfSide}%</td>
                                                <td>{item.pressureMax} kPa(r)</td>
                                                <td>{item.pressureMean} kPa(r)</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </li>
                    <li>
                        <table>
                            <thead>
                                <tr>
                                    <th>{`${i18n?.t("area")}(${i18n?.t("right")})`}</th>
                                    <th>{i18n?.t("superficialArea")}</th>
                                    <th>%</th>
                                    <th>{i18n?.t("force")}</th>
                                    <th>%</th>
                                    <th>{i18n?.t("maxPressure")}</th>
                                    <th>{i18n?.t("averagePressure")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.right.map((item) => {
                                        return (
                                            <tr key={item.key}>
                                                <td>{item.name}</td>
                                                <td>{item.area} cm²</td>
                                                <td>{item.areaOverSelfSide}%</td>
                                                <td>{item.load} Kgf</td>
                                                <td>{item.loadOverSelfSide}%</td>
                                                <td>{item.pressureMax} kPa(r)</td>
                                                <td>{item.pressureMean} kPa(r)</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </li>
                </ul>
                <ul className='text'>
                    <li>
                        <p><span>{i18n?.t("leftFoot")}</span>: <span>{conclusion.left.label}</span></p>
                        {
                            conclusion.left.text.map((item, index) => {
                                return (
                                    <p key={index}>{item}</p>
                                )
                            })
                        }
                    </li>
                    <li>
                        <p><span>{i18n?.t("rightFoot")}</span>: <span>{conclusion.right.label}</span></p>
                        {
                            conclusion.right.text.map((item, index) => {
                                return (
                                    <p key={index}>{item}</p>
                                )
                            })
                        }
                    </li>
                </ul>
            </div>
        )
    }
}

export default withTranslation()(FootPartition)